var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-detail06-template',{attrs:{"com-group-list":_vm.comGroupList,"board-ids":[107],"field-code":"public-transportation","graph1-title":"전체 (공중교통수단)안전·보건 교육 현황","graph2-title":"월별 (공중교통수단)안전·보건 교육 현황","graph3-title":"기간별 (공중교통수단)안전·보건 교육 현황"}})
}
var staticRenderFns = []

export { render, staticRenderFns }